// Mesa Heirloom masthead animation (July 2026)

const MastheadWrapper = document.querySelector('.MastheadWrapper');
const BackgroundRoot = document.querySelector('.MastheadBackground');
if (MastheadWrapper && BackgroundRoot) {
    // Element references
    const BackgroundOverlay = BackgroundRoot.querySelector('.MastheadBackground-background');
    const ForegroundElement = BackgroundRoot.querySelector('.MastheadBackground-key');
    const Segment1 = BackgroundOverlay.querySelector('.MastheadBackground-segment1');
    const Segment2 = BackgroundOverlay.querySelector('.MastheadBackground-segment2');
    const Segment3 = BackgroundOverlay.querySelector('.MastheadBackground-segment3');
    const GlassParallaxFactor = 0.5;

    // Tuning constants
    const FrameDuration = 1000 / 60; // 60 FPS
    const DriftDistance = 0.05; // +/- 2.5% translate
    const BackgroundDriftFactor = 0.5;
    const ForegroundDriftFactor = 1.0;

    const IdleEnabled = true; // Turn off for debug
    const IdleDelay = 3000; // Delay after last mouse over before auto drift starts
    const IdleEase = 3000; // Time it takes to ramp up to auto drift
    const IdleRotationRate = Math.PI / 450; // Full rotation in ~15s
    const IdleDistanceRate = 0.003; // Distance lock in ~10s

    // Calculate the offsets for an individual pane of glass
    // Exact offset and brightness vary to give the illusion of separate reflection angles
    function calcOffset(element, anchorX, anchorY, backgroundX, backgroundY, dX, dY) {
        const adj = dX - anchorX;
        const opp = dY - anchorY;
        const distance = Math.sqrt(adj * adj + opp * opp);
        const brightness = 1.2 - 0.2 * distance;

        element.style.filter = `brightness(${brightness})`;

        const xOffset = backgroundX - dX * GlassParallaxFactor;
        const yOffset = backgroundY - dY * GlassParallaxFactor;

        element.style.backgroundPosition = `${xOffset}%, ${yOffset}%`;
    }

    let lastMouseSync = Date.now();
    let lastMouseAngle = 0;
    let lastMouseDistance = 0;
    let lastMouseX = 0;
    let lastMouseY = 0;
    let targetMouseX = 0;
    let targetMouseY = 0;

    function sync(timestamp) {
        const syncElapsed = timestamp - lastMouseSync;
        if (IdleEnabled && syncElapsed > IdleDelay) {
            // Idle rotation
            const syncStrength = Math.min(1, (syncElapsed - IdleDelay) / IdleEase);
            lastMouseAngle += syncStrength * IdleRotationRate;
            if (lastMouseAngle > Math.PI) lastMouseAngle -= 2 * Math.PI;
            if (lastMouseDistance > 1) {
                lastMouseDistance = Math.max(1, lastMouseDistance - syncStrength * IdleDistanceRate);
            } else if (lastMouseDistance < 1) {
                lastMouseDistance = Math.min(1, lastMouseDistance + syncStrength * IdleDistanceRate);
            }
            targetMouseX = Math.cos(lastMouseAngle) * lastMouseDistance;
            targetMouseY = Math.sin(lastMouseAngle) * lastMouseDistance;
        }
        const dX = targetMouseX - lastMouseX;
        const dY = targetMouseY - lastMouseY;
        const distance = Math.sqrt(dX * dX + dY * dY);
        if (distance > DriftDistance) {
            lastMouseX += dX * (DriftDistance / distance);
            lastMouseY += dY * (DriftDistance / distance);
        } else {
            lastMouseX = targetMouseX;
            lastMouseY = targetMouseY;
        }

        const xOffset = -50.0 - lastMouseX * BackgroundDriftFactor;
        const yOffset = -50.0 - lastMouseY * BackgroundDriftFactor;
        BackgroundOverlay.style.transform = `translate(${xOffset}%,${yOffset}%)`;

        const xCounter = -50.0 + lastMouseX * ForegroundDriftFactor;
        const yCounter = -50.0 + lastMouseY * ForegroundDriftFactor;
        ForegroundElement.style.transform = `translate(${xCounter}%,${yCounter}%)`;

        calcOffset(Segment1, -0.5, -0.5, 51, 51, lastMouseX, lastMouseY);
        calcOffset(Segment2, -0.25, 0.5, 49.5, 49, lastMouseX, lastMouseY);
        calcOffset(Segment3, 0.5, -0.1, 49, 50, lastMouseX, lastMouseY);
    }
    let lastFrame = Date.now();
    function update() {
        const now = Date.now();
        if (now - lastFrame >= FrameDuration) {
            lastFrame = now;
            sync(now);
        }
        // Push debug text to masthead subtext section
        //document.querySelector('.Masthead-subtitle').innerText = lastMouseAngle.toFixed(4) + "," + lastMouseDistance.toFixed(4);
        requestAnimationFrame(update);
    }

    function syncMouse(event) {
        const rect = BackgroundRoot.getBoundingClientRect();
        const halfWidth = rect.width / 2;
        const halfHeight = rect.height / 2;
        targetMouseX = (event.clientX - (rect.left + halfWidth)) / halfWidth;
        targetMouseY = (event.clientY - (rect.top + halfHeight)) / halfHeight;
        lastMouseAngle = Math.atan2(targetMouseY, targetMouseX);
        lastMouseDistance = Math.sqrt(targetMouseX*targetMouseX + targetMouseY*targetMouseY);
        lastMouseSync = Date.now();
    }

    MastheadWrapper.addEventListener('mousemove', syncMouse);
    window.addEventListener('load', () => {
        BackgroundRoot.classList.add('is-active');
        lastMouseSync = Date.now();
        requestAnimationFrame(update);
    });
}

// Ember overlay animation
const CanvasElement = document.getElementById('ember-overlay');
if (CanvasElement) {
    const StartColor = {r:249,g:163,b:34};
    //const EndColor = {r:233,g:77,b:2};
    const EndColor = {r:76,g:24,b:29};
    const MoteDuration = 60;
    const EasingFunctions = [
        // easeOutQuad
        (x) => {
            return 1 - (1 - x) * (1 - x);
        },
        // easeOutCubic
        (x) => {
            return 1 - (1 - x) * (1 - x) * (1 - x);
        }
    ]

    const Width = parseFloat(CanvasElement.getAttribute("width"));
    const Height = parseFloat(CanvasElement.getAttribute("height"));
    const CanvasContext = CanvasElement.getContext("2d");
    const Motes = [];
    let lastUpdate = Date.now();
    let spawnAt = 0;

    function lerp(a, b, t) {
        return a + t * (b - a);
    }
    function drawPath(mote, timestamp, progress) {
        const Path = mote.path;
        const Cutoff = timestamp - MoteDuration;
        if (Path.length > 1) {
            CanvasContext.lineWidth = (3 - progress) * mote.size;
            CanvasContext.filter = `blur(${mote.size / 2}px)`;
            const red = Math.floor(lerp(StartColor.r,EndColor.r,progress));
            const green = Math.floor(lerp(StartColor.g,EndColor.g,progress));
            const blue = Math.floor(lerp(StartColor.b,EndColor.b,progress));
            const alpha = Math.min(1.3 - (mote.size / 6), 1);
            CanvasContext.strokeStyle = `rgb(${red},${green},${blue},${alpha})`;

            let point = Path[0];
            CanvasContext.beginPath();
            CanvasContext.moveTo(point.x, point.y);
            for (let i = 1; i < Path.length; i ++) {
                point = Path[i];
                if (point.timestamp < Cutoff) {
                    Path.splice(10);
                    break;
                }
                CanvasContext.lineTo(point.x, point.y);
            }
            CanvasContext.closePath();
            CanvasContext.stroke();
        }
    }

    function createMote(timestamp) {
        const origin = {
            x: (0.4 + Math.random() * 0.8) * Width,
            y: Height * 1.1,
        };
        const destination = {
            x: origin.x - (Math.random() * 0.8 + 0.4) * Width,
            y: Height * -0.1,
        }
        const size = 1.3 + (Math.random() * 2);
        const duration = 4000 - Math.floor(size * 500);
        Motes.push({
            timestamp,
            duration,
            size,
            arc: (Math.random() - 0.5) * Width * 0.3,
            origin,
            destination,
            ease: EasingFunctions[Math.floor(Math.random() * EasingFunctions.length)],
            path: [],
        })
    }

    function isInView() {
        const rect = CanvasElement.getBoundingClientRect();
        return (rect.bottom > 0 && rect.top < window.innerHeight);
    }

    function updateOverlay() {
        let timestamp = Date.now();
        if (timestamp > lastUpdate) {
            if (isInView()) {
                CanvasContext.clearRect(0, 0, CanvasElement.width, CanvasElement.height);

                if (timestamp > spawnAt) {
                    createMote(timestamp);
                    spawnAt = timestamp + 50 + Math.round(Math.random() * 300);
                }
                let mote, delta, progress, point, arc;
                for (let i = 0; i < Motes.length; i++) {
                    mote = Motes[i];
                    delta = timestamp - mote.timestamp;
                    if (delta > mote.duration) {
                        Motes.splice(i, 1);
                        i--;
                        continue;
                    }

                    progress = delta / mote.duration;
                    arc = Math.sin(progress * Math.PI) * mote.arc;
                    point = {
                        x: lerp(mote.origin.x, mote.destination.x, progress) + arc,
                        y: lerp(mote.origin.y, mote.destination.y, mote.ease(progress)),
                        timestamp
                    }
                    mote.path.unshift(point);
                    drawPath(mote, timestamp, progress);
                }
            }
            lastUpdate = timestamp;
        }
        requestAnimationFrame(updateOverlay);
    }
    updateOverlay();
}

